/**
 * Vite `base` 경로 헬퍼
 * - 운영(기본): /
 * - 서브경로 배포: DEPLOY_BASE=/dev/ 로 빌드
 */
export const BASE_URL = import.meta.env.BASE_URL;

/** 정적 호스팅에서 새로고침이 되도록 확장자 없는 페이지 경로에 / 를 붙입니다. */
function ensureDirPath(path: string): string {
  const hashIndex = path.indexOf('#');
  const queryIndex = path.indexOf('?');
  let cut = path.length;
  if (queryIndex >= 0) cut = Math.min(cut, queryIndex);
  if (hashIndex >= 0) cut = Math.min(cut, hashIndex);

  const pathname = path.slice(0, cut);
  const suffix = path.slice(cut);
  if (!pathname || pathname.includes('.') || pathname.endsWith('/')) {
    return path;
  }
  return `${pathname}/${suffix}`;
}

/** `/about` → `/about/` (base 반영, 새로고침용 trailing slash) */
export function withBase(path: string): string {
  if (/^(https?:|mailto:|tel:|#)/i.test(path)) return path;
  // 빌드 플러그인이 이미 base를 붙인 경우 중복 방지
  if (path.startsWith(BASE_URL)) return ensureDirPath(path);
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return `${BASE_URL}${ensureDirPath(normalized)}`;
}

/** base 접두사 제거 — `/about` (라우팅용) */
export function stripBase(pathname: string): string {
  const base = BASE_URL.replace(/\/+$/, '');
  if (!base || base === '') return pathname;

  if (pathname === base || pathname === `${base}/`) return '/';
  if (pathname.startsWith(`${base}/`)) {
    return pathname.slice(base.length) || '/';
  }
  return pathname;
}

/** 페이지 HTML 내 절대경로(/assets, /about 등)에 base 적용 */
export function applyBaseToHtml(html: string): string {
  const base = BASE_URL;
  if (base === '/') return html;

  return html
    .replace(/(src|href|poster)="\/assets\//g, `$1="${base}assets/`)
    .replace(/srcset="([^"]*)"/g, (_match, urls: string) => {
      const next = urls.replace(/(^|,\s*)\/assets\//g, `$1${base}assets/`);
      return `srcset="${next}"`;
    })
    .replace(/href="\/(?!\/)([^"]*)"/g, (_match, rel: string) => `href="${base}${ensureDirPath(rel)}"`);
}
